// Grafana-matched dark theme palette
const C = {
  page: "#111217",
  panel: "#181b1f",
  panelAlt: "#1f2229",
  header: "#111217",
  border: "#2c2f36",
  divider: "#2c2f36",
  text: "#ccccdc",
  bright: "#e6e6f0",
  dim: "#6e7681",
  faint: "#3d424d",
  green: "#2ea043",
  greenBg: "rgba(46,160,67,0.15)",
  red: "#f85149",
  redBg: "rgba(248,81,73,0.15)",
  blue: "#58a6ff",
  blueBg: "rgba(88,166,255,0.15)",
  purple: "#8957e5",
  orange: "#d29922",
  pillGreen: "#238636",
  pillBlue: "#1f6feb",
  pillPurple: "#8957e5",
  pillGray: "#30363d",
  pillGrayText: "#8b949e",
  inputBg: "#0d1117",
  inputBorder: "#30363d",
  inputFocus: "#58a6ff",
  overlay: "rgba(0,0,0,0.6)",
  star: "#d29922",
  starEmpty: "#3d424d",
  loser: "#8b949e",
};

export default C;
